import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserErrorsService } from "@app/user/user-core/services/user-errors.service";
import { ValidatorsUtil } from "@helper/validators-util";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: "app-nca-bind-popup",
  templateUrl: "./nca-bind-popup.component.html",
  styleUrls: ["./nca-bind-popup.component.scss"]
})
export class NcaBindPopupComponent implements OnInit {
	public form: FormGroup;

	constructor(
		public config: DynamicDialogConfig,
		public ref: DynamicDialogRef,
		private fB: FormBuilder,
		private userErrorsService: UserErrorsService,
	) {
		this.form = this.fB.group({ serualNumber: [null, [Validators.required]] });
	}

	public ngOnInit(): void {
		this.setData();
	}

	public confirm(form: FormGroup): void {
		ValidatorsUtil.triggerValidation(form);
		if (form.invalid) {
			this.userErrorsService.displayErrors(form, undefined, undefined, true);
			return;
		}
		this.ref.close(form.getRawValue().serualNumber);
	}

	public close(): void {
		this.ref.close();
	}
	
	private setData(): void {
		this.config.width = "600px";
		this.config.header = "Ввод данных сертификата";
		for (let k in this.config.data) {
			(this as any)[k] = this.config.data[k];
		}
	}
}
